import React from "react";

import styles from "../../styles/Leaderboard.module.css";
const DummyLeaderboard = () => {
  return [...Array(10).keys()].map((c, index) => (
    <div
      className={styles.Leaderboard__card}
      style={{ overflow: "hidden", position: "relative" }}
      key={index}
    >
      <div className={styles.Leaderboard__card__section1}>
        <div
          className="skeleton text"
          style={{
            width: "180px",
            height: "15px",
            borderRadius: "5px",
            marginBottom: "10px",
          }}
        />

        <div
          className="skeleton text"
          style={{
            width: "180px",
            height: "15px",
            borderRadius: "5px",
            marginBottom: "10px",
          }}
        />

        <div
          className="skeleton text"
          style={{
            width: "180px",
            height: "15px",
            borderRadius: "5px",
            marginBottom: "10px",
          }}
        />
      </div>
      <div className={styles.Leaderboard__card__section2}>
        <div
          className="skeleton text"
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "5px",
            marginBottom: "10px",
          }}
        />
      </div>
      <div className="shimmer-wrapper">
        <div className="shimmer"></div>
      </div>
    </div>
  ));
};

export default DummyLeaderboard;
